<template>
  <div class="claim-type-form-step flex flex-col gap-8">
    <div class="claim-type-form-step-name font-bold mt-10">
      {{ claimTypeStepTitle }}
    </div>
    <div
      class="claim-type-form-step-items-wrapper mb-10 flex flex-col gap-8 items-center"
    >
      <draggable
        :value="claimTypeStepItems"
        @start="drag = true"
        @end="handleDragEnd"
        class="flex flex-col gap-8 w-full"
        :options="{ handle: '.claim-type-step-item-drag-handle' }"
      >
        <ClaimTypeFormStepItem
          v-for="(claimTypeStepItem, index) in claimTypeStepItems"
          :key="`${claimTypeStepItem.id}-${index}`"
          :claimTypeStepItem="claimTypeStepItem"
          :deleteClaimItem="() => deleteClaimItem(index)"
          :handleClickQuestion="handleClickClaimItemQuestion"
          :handleChangeMandatory="handleChangeMandatoryCreator(index)"
        ></ClaimTypeFormStepItem>
      </draggable>
      <common-add-button
        :click="handleClickAddRequireInformationBtn"
        title="必要情報追加"
        icon="PlusIcon"
      ></common-add-button>
      <common-modal
        title="必要情報選択"
        ref="EditModal"
        modalClass="select-require-info-modal"
        contentsClass="select-require-info-modal-contents flex flex-col gap-12 h-full"
      >
        <template v-slot:contents>
          <div class="search-require-info-area px-10">
            <div class="search-input-area flex gap-5 flex-wrap">
              <search-input
                placeholder="必要情報名"
                :onInput="
                  value => {
                    claimItemSearchWord = value;
                  }
                "
              ></search-input>
              <div class="select-format-area">
                <hull-dropdown-select
                  class="filter-input"
                  :selectOptions="inputTypeSelectOptions"
                  :onSelect="() => {}"
                  :selectedValue.sync="claimItemSearchType"
                  :onViewButtonClick="() => {}"
                  :viewButton="false"
                  :border="true"
                  :disabled="false"
                  clearable
                ></hull-dropdown-select>
              </div>
            </div>
          </div>
          <component
            :is="scrollbarTag"
            class="flex flex-col flex-grow-0 min-h-0 h-full"
            :key="$vs.rtl"
          >
            <div class="check-require-info-area w-full px-4 mt-6">
              <div class="flex flex-wrap row-gap-6 col-gap-6">
                <span
                  class="claim-item-check-box w-full flex items-start"
                  :key="claimItem.id"
                  v-for="claimItem of claimItemSwitches"
                >
                  <vs-checkbox
                    class="ml-0"
                    :value="selectedClaimItems[claimItem.id] || false"
                    :color="AISEA_COLOR.BLUE"
                    @change="handleChangeClaimItemCheckBox(claimItem)"
                  >
                  </vs-checkbox>
                  <span
                    class="claim-item-name cursor-pointer flex items-start gap-2 break-all"
                    @click.stop.prevent="
                      handleClickClaimItemDescription(claimItem)
                    "
                    @change.stop.prevent=""
                  >
                    <feather-icon
                      v-if="inputTypeMap[claimItem.inputType]"
                      class="custom-feather-icon mt-1"
                      :icon="inputTypeMap[claimItem.inputType].featherIconName"
                      svgClasses="h-4 w-4"
                    />
                    {{ claimItem.name }}
                  </span>
                </span>
              </div>
            </div>
          </component>
          <div class="select-require-info-modal-form-container">
            <div class="button-area flex justify-center">
              <common-button
                class="select-require-info-btn"
                title="追加"
                :click="() => addClaimItems()"
                :disabled="!isValidSelectedClaimItems"
              ></common-button>
            </div>
          </div>
        </template>
      </common-modal>
      <common-modal
        :title="
          (claimItemToBeShowDescription && claimItemToBeShowDescription.name) ||
            ''
        "
        ref="DescriptionModal"
        modalClass="select-require-info-modal-description-modal"
      >
        <template v-slot:contents>
          <div
            class="description-input-type-container flex items-center gap-2 mb-6"
            v-show="isShowInformationType"
          >
            <span class="description-input-type">情報形式: </span>
            <span class="select-item flex items-center gap-2">
              <feather-icon
                class="custom-feather-icon"
                :icon="displayDescriptionInputType.featherIconName"
                svgClasses="h-4 w-4"
              />
              <span>{{ displayDescriptionInputType.text }}</span>
              <feather-icon
                class="view-icon"
                icon="EyeIcon"
                svgClasses="h-6 w-6"
                @click.stop.prevent="showLightbox"
              />
            </span>
          </div>
          <div class="description-container">
            <div class="description-title">
              管理者専用説明
            </div>
            <div class="description-content">
              {{ displayDescriptionOwner }}
            </div>
            <div class="description-title mt-8">
              保険契約者向け説明
            </div>
            <div class="description-content">
              {{ displayDescriptionInsurer }}
            </div>
          </div>
          <light-box
            ref="lightbox"
            v-if="lightBoxMediaList.length != 0"
            :media="lightBoxMediaList"
            :show-light-box="false"
            :show-thumbs="false"
            :show-caption="false"
            :disableScroll="false"
          >
          </light-box>
        </template>
      </common-modal>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import isString from "lodash/isString";
import isObject from "lodash/isObject";
import cloneDeep from "lodash/cloneDeep";
import mapKeys from "lodash/mapKeys";
import ClaimTypeFormStepItem from "./ClaimTypeFormStepItem.vue";
import claimTemplateService from "@/services/claimTemplateService";
const ClaimTypeStep = claimTemplateService.getClaimTypeStepClass();
const ClaimTypeStepItem = claimTemplateService.getClaimTypeStepItemClass();
import CommonAddButton from "../components/molecules/CommonAddButton.vue";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonModal from "../components/organisms/CommonModal.vue";
import SearchInput from "../components/molecules/SearchInput";
import HullDropdownSelect from "../components/molecules/HullDropdownSelect.vue";
import Vue from "vue";
import { ColorMixin } from "@/mixins";
import LightBox from "vue-image-lightbox";
import { HULL_INSURANCE_INPUT_TYPE } from "@/config/const";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    ClaimTypeFormStepItem,
    draggable,
    CommonAddButton,
    CommonButton,
    CommonModal,
    SearchInput,
    HullDropdownSelect,
    LightBox,
    VuePerfectScrollbar,
  },
  mixins: [ColorMixin],
  name: "O.ClaimTypeFormStep",
  props: {
    initialClaimTypeStep: {
      type: ClaimTypeStep,
      required: true,
    },
    claimItems: {
      type: Array, // Array<ClaimItem>
      default() {
        return [];
      },
    },
    checkHasAddedClaimItem: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      claimItemSearchWord: "",
      claimItemSearchType: null,
      selectedClaimItems: {
        // [claimItem.id]: boolean
      },
      claimItemIdToShowDescription: "",
      claimTypeStep: null,
      drag: false,
      isShowInformationType: false,
    };
  },
  watch: {
    initialClaimTypeStep: {
      handler() {
        this.claimTypeStep = isObject(this.initialClaimTypeStep)
          ? cloneDeep(this.initialClaimTypeStep)
          : new ClaimTypeStep();
      },
      immediate: true,
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    lightBoxMediaList() {
      return HULL_INSURANCE_INPUT_TYPE.filter(element => {
        return element.value == this.displayDescriptionInputType.value;
      }).map(element => {
        return {
          src: element.previewSrc,
        };
      });
    },
    hasClaimTypeStepItems() {
      if (!this.claimTypeStep) return false;
      return Array.isArray(this.claimTypeStep.claimTypeStepItems);
    },

    claimTypeStepTitle() {
      if (!this.hasClaimTypeStepItems) return "";
      return this.claimTypeStep.name;
    },

    claimTypeStepItems() {
      if (!this.hasClaimTypeStepItems) return [];
      return this.claimTypeStep.claimTypeStepItems;
    },
    inputTypeSelectOptions() {
      return HULL_INSURANCE_INPUT_TYPE.filter(
        inputType => inputType.isUsedInClaimTemplate
      );
    },
    hasClaimItems() {
      return Array.isArray(this.claimItems);
    },
    hasClaimItemSearchWord() {
      return (
        isString(this.claimItemSearchWord) &&
        this.claimItemSearchWord.length > 0
      );
    },
    hasClaimItemSearchType() {
      return new Set(
        HULL_INSURANCE_INPUT_TYPE.map(inputType => inputType.value)
      ).has(this.claimItemSearchType);
    },

    claimItemsMappedByInputType() {
      if (!this.hasClaimItems)
        return this.createInitialClaimItemsMappedByInputType();
      return this.claimItems
        .filter(claimItem => claimItem)
        .reduce((acc, cur) => {
          if (Array.isArray(acc[cur.inputType])) {
            acc[cur.inputType].push(cur);
          }
          return acc;
        }, this.createInitialClaimItemsMappedByInputType());
    },
    claimItemsFilteredByInputType() {
      if (!this.hasClaimItemSearchType) return this.claimItems;
      return this.claimItemsMappedByInputType[this.claimItemSearchType];
    },
    claimItemsFilteredByInputTypeAndName() {
      if (!this.hasClaimItems) return [];
      if (!this.hasClaimItemSearchWord) {
        return this.claimItemsFilteredByInputType;
      }
      return this.claimItemsFilteredByInputType.filter(
        claimItem =>
          claimItem.name && claimItem.name.includes(this.claimItemSearchWord)
      );
    },
    claimItemSwitches() {
      return this.claimItemsFilteredByInputTypeAndName.map(claimItem => ({
        ...claimItem,
        selected: !!this.selectedClaimItems[claimItem.id],
      }));
    },
    inputTypeMap() {
      return mapKeys(HULL_INSURANCE_INPUT_TYPE, "value");
    },
    claimItemToBeShowDescription() {
      if (!this.claimItemIdToShowDescription) return null;
      return (
        this.claimItems.find(
          claimItem => claimItem.id === this.claimItemIdToShowDescription
        ) || null
      );
    },
    isShowModalDescription() {
      return (
        isString(this.claimItemIdToShowDescription) &&
        this.claimItemIdToShowDescription.length > 0
      );
    },
    displayDescriptionInputType() {
      if (!this.claimItemToBeShowDescription) return {};
      return this.inputTypeMap[this.claimItemToBeShowDescription.inputType];
    },
    displayDescriptionOwner() {
      if (!this.claimItemToBeShowDescription) return "";
      return this.claimItemToBeShowDescription.descriptionOwner;
    },
    displayDescriptionInsurer() {
      if (!this.claimItemToBeShowDescription) return "";
      return this.claimItemToBeShowDescription.descriptionInsurer;
    },
    isValidSelectedClaimItems() {
      return this.claimItemSwitches.some(
        claimItemSwitch => claimItemSwitch.selected
      );
    },
  },

  methods: {
    handleDragEnd(evt) {
      this.drag = false;

      const { oldIndex, newIndex } = evt;
      const draggedStep = this.claimTypeStepItems[oldIndex];
      this.claimTypeStep.claimTypeStepItems.splice(oldIndex, 1);
      this.claimTypeStep.claimTypeStepItems.splice(newIndex, 0, draggedStep);
      Vue.set(
        this.claimTypeStep,
        "claimTypeStepItems",
        this.claimTypeStep.claimTypeStepItems
      );
    },
    handleClickAddRequireInformationBtn() {
      this.initClaimTypeEditModalConditions();
      this.$refs.EditModal.show();
    },
    closeEditModal() {
      this.$refs.EditModal.close();
    },
    filterClaimItemsBySearchWord(claimItems) {
      return claimItems
        .filter(claimItem => claimItem)
        .filter(
          claimItem =>
            claimItem.name && claimItem.name.includes(this.claimItemSearchWord)
        );
    },
    filterClaimItemsBySearchType(inputType) {
      return this.claimItemsMappedByInputType[inputType] || [];
    },
    createInitialClaimItemsMappedByInputType() {
      return HULL_INSURANCE_INPUT_TYPE.reduce((acc, cur) => {
        acc[cur.value] = [];
        return acc;
      }, {});
    },
    onSelectClaimItemSearchType(value) {
      this.claimItemSearchType = value;
    },
    handleChangeClaimItemCheckBox(claimItem) {
      Vue.set(
        this.selectedClaimItems,
        claimItem.id,
        !this.selectedClaimItems[claimItem.id]
      );
    },
    handleClickClaimItemDescription(claimItem) {
      this.claimItemIdToShowDescription = claimItem.id;
      this.isShowInformationType = true;
      this.$refs.DescriptionModal.show();
    },
    handleClickClaimItemQuestion(claimItem) {
      this.claimItemIdToShowDescription = claimItem.id;
      this.isShowInformationType = false;
      this.$refs.DescriptionModal.show();
    },
    showLightbox() {
      this.$refs.lightbox.showImage(0);
    },
    addClaimItems() {
      this.claimItems
        .filter(claimItem => claimItem && this.selectedClaimItems[claimItem.id])
        .forEach((claimItem, index) => {
          this.claimTypeStep.addClaimTypeStepItem(
            new ClaimTypeStepItem({
              mandatory: true,
              sort_order: this.claimTypeStepItems.length + index,
              claim_item: {
                id: claimItem.id,
                name: claimItem.name,
                input_type: claimItem.inputType,
                choices: claimItem.choices,
                description_insurer: claimItem.descriptionInsurer,
                description_owner: claimItem.descriptionOwner,
              },
            })
          );
        });
      this.selectedClaimItems = {};
      this.checkHasAddedClaimItem();
      setTimeout(() => {
        this.closeEditModal();
      });
    },
    deleteClaimItem(claimItemIndex) {
      Vue.set(
        this.claimTypeStep,
        "claimTypeStepItems",
        this.claimTypeStep.claimTypeStepItems.filter(
          (_claimItem, index) => index !== claimItemIndex
        )
      );
    },
    handleChangeMandatoryCreator(claimItemIndex) {
      return nextMandatory => {
        Vue.set(
          this.claimTypeStep,
          "claimTypeStepItems",
          this.claimTypeStep.claimTypeStepItems.map((claimStepItem, index) => {
            if (index === claimItemIndex) {
              const nextClaimStepItem = cloneDeep(claimStepItem);
              nextClaimStepItem.mandatory = nextMandatory;
              return nextClaimStepItem;
            }
            return claimStepItem;
          })
        );
      };
    },
    initClaimTypeEditModalConditions() {
      this.claimItemSearchWord = "";
      this.claimItemSearchType = null;
      this.selectedClaimItems = {};
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.claim-type-form-step {
  border-bottom: #d9d9d9 solid 1px;
  &-name {
    color: #757575;
    font-size: 16px;
  }
}
#common-modal {
  &.select-require-info-modal {
    .vs-dialog {
      max-width: 780px;
      width: 100%;
      max-height: 600px;
      height: 100%;
      .vs-dialog-text {
        height: 100%;
        max-height: 600px;
        overflow: hidden;
      }
      .search-require-info-area {
        gap: 20px;
      }
      .search-input {
        width: 100%;
        flex-grow: 1;
        flex-shrink: 0;
      }
      .select-format-area {
        width: 100%;
      }
      @media (min-width: 780px) {
        .search-input {
          max-width: 370px;
          width: 100%;
        }
        .select-format-area {
          max-width: 280px;
          width: 100%;
        }
      }
      .select-require-info-modal-contents {
        max-height: 545px;
        .select-require-info-modal-form-container {
          padding-bottom: 50px;
        }
      }
      .check-require-info-area {
        .claim-item-check-box {
          max-width: 210px;
        }
      }
      .select-require-info-btn {
        width: 200px;
      }
    }
  }
  &.select-require-info-modal-description-modal {
    z-index: 52008;
    .common-text-medium {
      font-size: 20px;
    }
    .description-input-type-container {
      .description-input-type {
        font-weight: bold;
      }
    }
    .description-container {
      .description-title {
        font-weight: bold;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
